import {
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
  Search,
} from '@mui/icons-material'
import {
  Box,
  IconButton,
  Input,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import { useState } from 'react'
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table'

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, {
    keys: [(row) => row.values[id]],
  })
}
fuzzyTextFilterFn.autoRemove = (val) => !val

export default function BasicTable({ columns, data, hideColumns }) {
  const [filterInput, setFilterInput] = useState('')

  const tableProps = {
    columns,
    data,
    ...(hideColumns && {
      initialState: {
        hiddenColumns: hideColumns,
      },
    }),
    filterTypes: {
      fuzzyText: fuzzyTextFilterFn,
    },
  }
  const firstHeader =
    columns && columns.length > 0
      ? typeof columns[0].Header === 'function'
        ? columns[0].Header()
        : columns[0].Header
      : 'Search...'
  const {
    getTableProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      ...tableProps,
      globalFilter: filterInput,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  )

  const handleFilterChange = (e) => {
    const value = e.target.value || ''
    setFilterInput(value)
    setGlobalFilter(value)
  }

  return (
    <>
      <Input
        value={filterInput}
        onChange={handleFilterChange}
        placeholder={`Search ${firstHeader.toLowerCase()}...`}
        style={{
          marginBottom: '8px',
          height: '56px',
          padding: '15px',
          minWidth: '350px',
        }}
        endAdornment={<Search />}
      />
      <Table {...getTableProps()}>
        <TableHead>
          {headerGroups.map((headerGroup, index) => (
            <TableRow key={index} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <TableCell
                  key={index}
                  {...column.getHeaderProps(
                    column.sortable ? column.getSortByToggleProps() : {},
                  )}
                >
                  {column.render('Header')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <TableRow key={i} {...row.getRowProps()} sx={{ height: 20 }}>
                {row.cells.map((cell) => {
                  return (
                    <TableCell
                      key={i}
                      {...cell.getCellProps()}
                      sx={{
                        py: 0.5,
                        minWidth: cell.column.minWidth
                          ? cell.column.minWidth
                          : 0,
                      }}
                    >
                      {cell.render('Cell')}
                    </TableCell>
                  )
                })}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 2,
          gap: '5px',
        }}
      >
        <IconButton onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          <FirstPage />
        </IconButton>
        <IconButton onClick={() => previousPage()} disabled={!canPreviousPage}>
          <ChevronLeft />
        </IconButton>
        <span>
          Page {pageIndex + 1} of {pageOptions.length || '1'}
        </span>
        <IconButton onClick={() => nextPage()} disabled={!canNextPage}>
          <ChevronRight />
        </IconButton>
        <IconButton
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
        >
          <LastPage />
        </IconButton>
      </Box>
    </>
  )
}
